import { useSelector } from 'react-redux';
import useTranslation from 'next-translate/useTranslation';
import Link from 'next/link';
import Image from 'next/image';

import { selectors as cabinetSelectors } from '@/domains/cabinet';
import { CloseMobile } from '@/icons/index';

import { AppBanner } from '../AppBanner/AppBanner';
import { LoginForm } from '../LoginForm/LoginForm';
import { OtpVerify } from '../OtpVerify/OtpVerify';

import styles from './Login.module.scss';

export const Login = ({ googleReCaptchaProps, item }) => {
  const { currentStep } = useSelector(cabinetSelectors.selectCabinet);
  const { t } = useTranslation();

  const stepComponents = {
    1: <LoginForm googleReCaptchaProps={googleReCaptchaProps} />,
    2: <OtpVerify />,
  };
  return (
    <div
      className={`${styles.loginWrapper} wrapper`}
      itemScope
      itemType='https://schema.org/WebPage'
    >
      <div data-testid='login-close-btn' className={styles.close}>
        <Link href='/'>
          <a>
            <CloseMobile />
          </a>
        </Link>
      </div>
      <AppBanner item={item} />
      <div className={styles.loginFormWrapper}>
        <div className={styles.loginFormWrapper__logo}>
          <Link href='/'>
            <a>
              <Image
                alt='logo'
                title='logo'
                src='/data/new-logo.svg'
                width={228}
                height={44}
              />
            </a>
          </Link>
        </div>
        <div className={styles.loginFormWrapper__title}>
          <span>{t('cabinet:common.SignIn')}</span>
        </div>
        {stepComponents[currentStep]}
      </div>
    </div>
  );
};
